import { Injectable } from '@angular/core';
import { EWayType } from 'app_locobook/air-search/air-search-form/air-search-segment-multiple/air-search-segment-multiple.component';
import { Subject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AirSearchHeaderActionService {
    public readonly wayTypeChangeObservable: Observable<EWayType>;
    public readonly isAirSearchFormVisibleObservable: Observable<boolean>;
    public readonly resetAirSearchFormObservable: Observable<void>;
    private readonly resetAirSearchFormSubject: Subject<void> = new Subject<void>();
    private readonly wayTypeChangeSubject: Subject<EWayType> = new Subject<EWayType>();
    private readonly isAirSearchFormVisibleSubject: Subject<boolean> = new Subject<boolean>();

    constructor() {
        this.wayTypeChangeObservable = this.wayTypeChangeSubject.asObservable();
        this.isAirSearchFormVisibleObservable = this.isAirSearchFormVisibleSubject.asObservable();
        this.resetAirSearchFormObservable = this.resetAirSearchFormSubject.asObservable();
    }

    public onWayTypeChange(wayType: EWayType): void {
        this.wayTypeChangeSubject.next(wayType);
    }

    public onResetAirSearchForm(): void {
        this.resetAirSearchFormSubject.next();
    }

    public onToggleIsAirSearchFormVisible(isAirSearchFormVisible: boolean): void {
        this.isAirSearchFormVisibleSubject.next(isAirSearchFormVisible);
    }
}